import React from "react";
import { getLoggedUser } from "../../context/auth";

let loggedUser = {};
const GlobalConfig = new window.globalConfig();

class App extends React.Component {
  constructor(props) {
    super();
    loggedUser = getLoggedUser();

    let urlGetGrowers = ``;
    if (props.checkExistPaymentSetting) {
      urlGetGrowers = `${GlobalConfig.REACT_APP_API_GROWER_URL}simpleGrowersExistPayment/${loggedUser.referenceUserId}/${props.testTypeId}/${props.cropYearId}`;
    } else {
      urlGetGrowers = `${GlobalConfig.REACT_APP_API_GROWER_URL}simpleGrowersByProcessorAndTestType/${loggedUser.referenceUserId}/${props.testTypeId}`;
    }

    this.state = {
      name: props.name,
      //Get growers by Processor ID and Test Type ID
      urlGetGrowers: urlGetGrowers,
      value:
        props.value === null || props.value === undefined ? `` : props.value,
      data: [],
    };
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
  }

  async componentDidMount() {
    //using for parent call method setSelected outside
    this.props.onRef(this);

    //query all items in module and render as checkbox list
    this.getItems();
  }

  componentWillUnmount() {
    //using for parent call method setSelected outside
    this.props.onRef(undefined);
  }

  getItems = async () => {
    try {
      const that = this;
      fetch(this.state.urlGetGrowers)
        .then(function (response) {
          return response.json();
        })
        .then(function (resultObject) {
          if (
            resultObject &&
            resultObject.result === "OK" &&
            resultObject.data
          ) {
            const parsedItems = [];
            resultObject.data.map((item) => {
              parsedItems.push({
                _id: item._id,
                name: item.name,
                checked:
                  that.state.value === null ||
                  that.state.value === undefined ||
                  that.state.value === "" ||
                  that.state.value.indexOf(item._id) === -1
                    ? false
                    : true,
              });
            });
            that.setState({
              data: parsedItems,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  setSelected(selectedIds) {
    this.setState({ value: selectedIds });
    if (this.state.data) {
      let updatedData = this.state.data;
      updatedData.forEach((item) => {
        if (
          selectedIds == null ||
          selectedIds == undefined ||
          selectedIds.indexOf(item._id) == -1
        ) {
          item.checked = false;
        } else {
          item.checked = true;
        }
      });
      this.setState({ data: updatedData });
    }
  }

  handleChangeSelect(event) {
    const value = event.target.value;
    this.setState({ value: value });
    this.props.handleChangeSelectGrower(this.state.name, value);
  }

  render() {
    return (
      <select
        disabled={this.props.readOnly}
        name={this.state.name}
        className="form-control"
        required={this.props.required}
        onChange={this.handleChangeSelect}
        value={this.state.value}
      >
        <option value="">Default</option>
        {this.state.data
          ? this.state.data.map((item, key) => {
              return (
                <option value={item._id} key={item._id}>
                  {item.name}
                </option>
              );
            })
          : ""}
      </select>
    );
  }
}
export default App;
